import list from 'src/modules/nutritionInformation/list/nutritionInformationListReducers';
import form from 'src/modules/nutritionInformation/form/nutritionInformationFormReducers';
import view from 'src/modules/nutritionInformation/view/nutritionInformationViewReducers';
import destroy from 'src/modules/nutritionInformation/destroy/nutritionInformationDestroyReducers';
import importerReducer from 'src/modules/nutritionInformation/importer/nutritionInformationImporterReducers';
import { combineReducers } from 'redux';

export default combineReducers({
  list,
  form,
  view,
  destroy,
  importer: importerReducer,
});
